module.exports = __webpack_public_path__ + "static/img/texture.877d6e2d.png";